import { render } from "./PurchaseOrderItem.vue?vue&type=template&id=f7e5b990&ts=true"
import script from "./PurchaseOrderItem.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__